import { Model } from '@/models/Model';
export class Portfolio extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Portfolio';
        this.$endpoint = '/portfolios';
        this.$fillable = [];
    }
    updatePortfolio(payload) {
        const url = `${this.$endpoint}`;
        return this.request('put', url, payload);
    }
    createRelation(portfolioId, relationshipType, payload) {
        const url = this.createRelationshipUrl(portfolioId, relationshipType);
        return this.request('post', url, payload);
    }
    updateRelation(portfolioId, relationshipType, relationshipTypeId, payload) {
        const url = this.createRelationshipUrl(portfolioId, relationshipType, relationshipTypeId);
        return this.request('put', url, payload);
    }
    deleteRelation(portfolioId, relationshipType, relationshipTypeId) {
        const url = this.createRelationshipUrl(portfolioId, relationshipType, relationshipTypeId);
        return this.request('delete', url);
    }
    deleteRelationWithPayload(portfolioId, relationshipType, payload) {
        const url = this.createRelationshipUrl(portfolioId, relationshipType);
        return this.request('delete', url, payload);
    }
    uploadFileInPortfolio(portfolioId, payload) {
        const url = `${this.$endpoint}/${portfolioId}/upload`;
        return this.request('post', url, payload);
    }
    deleteFileFromPortfolio(portfolioId, mediaId) {
        const url = `${this.$endpoint}/${portfolioId}/delete-upload/${mediaId}`;
        return this.request('delete', url);
    }
    getPdf(id) {
        const url = this.$endpoint + '/' + id;
        return this.request('get', url, {}, true);
    }
    createRelationshipUrl(portfolioId, relationshipType, relationshipTypeId) {
        if (relationshipType === 'rate') {
            return `${this.$endpoint}/${portfolioId}/relationships/skills/${relationshipTypeId || ''}/rate`;
        }
        return `${this.$endpoint}/${portfolioId}/relationships/${relationshipType}${relationshipTypeId ? `/${relationshipTypeId}` : ''}`;
    }
}
